export const theRandomNumber = Math.floor(Math.random() * 9000 + 1000);
